import React from 'react';
import Loadable from 'react-loadable';

import loadable from '@loadable/component';

const LoadingSpinner = loadable(() =>
  import('../../../../components/loading_spinner/loading_spinner')
);

let Component = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  Component = require('../login_page').default;
}

export default function(store) {
  const routeConfig = {
    path: '/login',
    component() {
      if (Component) {
        return <Component />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk() {
      return import(/* webpackChunkName: "loginPage" */ '../login_page').then(
        resp => {
          Component = resp.default;
          // routeConfig.loadData = () => {};
          return Component;
        }
      );
    },
    chunk: 'loginPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="login-page">
          <article className="login-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}
